export default __webpack_public_path__ + "static/media/default_avatar.b43d61ea.png";